/* global google */
export function convertGoogleMapsPlaceToAliadaLocation (place = {}) {
  if (!place.gmaps) {
    return place
  }

  const address = convertGoogleMapsPlaceToAddress(place)
  const {
    location: coordinates,
    label
  } = place

  return {
    coordinates,
    label,
    address
  }
}

export function convertGoogleMapsPlaceToAddress (place = {}) {
  if (!place.gmaps) {
    return place
  }

  const getLongnameOf = getLongNameForType.bind(null, place)
  return {
    street: getLongnameOf('route'),
    number: getLongnameOf('street_number'),
    colony: getLongnameOf('sublocality_level_1'),
    neighborhood: getLongnameOf('sublocality_level_1'),
    state: getLongnameOf('administrative_area_level_1'),
    city: getLongnameOf('administrative_area_level_3'),
    postal_code_number: getLongnameOf('postal_code')
  }
}

function getLongNameForType (place, type) {
  const components = place.gmaps.address_components

  const found = components.find((component) => {
    return component.types.indexOf(type) !== -1
  })

  return (found && found.long_name) || ''
}

export function geocode (address) {
  const geocoder = new google.maps.Geocoder()

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      const firstSuggestion = status === 'OK' && results[0]
      if (firstSuggestion) {
        resolve(firstSuggestion.geometry.location.toJSON())
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/shared/utils/google-maps.js